import { FormattedMessage } from "react-intl";
import workspaceEmpty from "@/assets/workspace_empty.svg";
import { PlusIcon } from "@/icons";
import { Link } from "@/kit/ui/link";

export default function WorkspacesEmpty({
  createWorkspacePath,
}: {
  createWorkspacePath: string;
}) {
  return (
    <div className="flex flex-col items-center gap-6">
      <img src={workspaceEmpty} />
      <div className="flex flex-col items-center gap-1 w-80">
        <p className="text-grey-900 text-lg font-semibold">
          <FormattedMessage defaultMessage="Create your first workspace" />
        </p>
        <p className="text-grey-600 text-sm font-normal text-center">
          <FormattedMessage defaultMessage="Build, run and share your quantum solutions with others, all from your browser." />
        </p>
      </div>

      <Link variant="primary" to={createWorkspacePath}>
        <PlusIcon className="w-5 h-5" />
        <FormattedMessage defaultMessage="Create workspace" />
      </Link>
    </div>
  );
}
